<section [className]="dismissed ? 'alert__banner alert__banner--hide' : 'alert__banner'" *ngIf="banner">
  <div [className]="dismissed ? 'alert__container alert__container--hide' : 'alert__container'" [ngStyle]="banner.styles">
    <div class="alert__alarm icon-alarm-sound"></div>
    <div class="alert__message" [innerHTML]="banner.message"></div>
    <div class="alert__close-box icon-close" (click)="dismiss()"></div>
  </div>
</section>
